








import Vue from 'vue'
import { PropValidator } from 'vue/types/options'  // using "as () => T" seems enough
import { IDevice, IVW } from '@/types/model'
import { setInterval } from 'timers'
import { getVwTxColor, getVwScreenColor } from '@/vw_algorithm'
import { thumb_size_t } from '@/store/modules/pref'
import { geometry_size_t, screen_style_t, tx_area_style_t } from '@/vw_algorithm'
import { getDevName } from '@/store/modules/device'

export default Vue.extend({
  model: {
    prop: 'device'
  },
  props: {
    vw: {
      type: Object
    } as PropValidator<IVW>,
    thumbSize: {
      type: String,
      default: 'md'
    } as PropValidator<thumb_size_t>,
    /**
     * width and height has higher priority than thumbSize.
     * Don't specify width and height simultaneously.
     */
    width: {
      type: Number,
      default: 0
    },
    /**
     *  width and height has higher priority than thumbSize
     * Don't specify width and height simultaneously.
     */
    height: {
      type: Number ,
      defualt: 0
    },
    showIndexes: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    columns (): number { return this.vw ? this.vw.layout.columns : 1 },
    rows (): number { return this.vw ? this.vw.layout.rows : 1 },
    rootSize (): geometry_size_t {
      if (this.width) {
        return { width: this.width, height: this.width * 5 / 9 }
      } else if (this.height) {
        return { width: this.height * 9 / 5, height: this.height }
      } else {
        let w = 0
        switch (this.thumbSize) {
          case 'xs': w = 40; break
          case 'sm': w = 90; break
          case 'md': w = 110; break
          case 'lg': w = 170; break
          case 'xl': w = 240; break
        }
        while (this.$state.common.windowSize.width - w < 200) {
          w --
        }
        return { width: w, height: w * 5 / 9 }
      }
    },
    rootStyle (): string {
      return `width:${this.rootSize.width}px;height:${this.rootSize.height}px;`
    },
    screensContainerSize (): geometry_size_t {
      return {
        width: this.screenSize.width * this.columns,
        height: this.screenSize.height * this.rows
      }
    },
    screensContainerStyle (): string {
      return `width:${this.screensContainerSize.width}px;height:${this.screensContainerSize.height}px;`
    },
    screenSize (): geometry_size_t {
      if (this.columns > this.rows) {
        const w = this.rootSize.width / this.columns
        const h = w * 5 / 9
        return { width: w, height: h }
      } else {
        const h = this.rootSize.height / this.rows
        const w = h * 9 / 5
        return { width: w, height: h }
      }
    },
    screenCommonStyle (): string {
      return `width:${this.screenSize.width}px;height:${this.screenSize.height}px;`
    },
    screenList (): screen_style_t[] {
      return this.vw.rxList.map((rx) => {
        const tmp: screen_style_t = {
          displayIndex: rx.displayIndex,
          style: this.screenCommonStyle,
          clickable: false,
          hasBezelSet: false,
          rxSelected: false,
          osd: 0,
        }
        if (rx.mac === '') {
          // The position of this VW has no RX mapped.
          tmp.style += 'opacity: 0.5;'
          return tmp
        }
        const screenClr = getVwScreenColor(rx, this.vw)
        if (screenClr) {
          tmp.style = tmp.style + `background-color:${screenClr.bg};`
        }
        return tmp
      })
    },
    txAreaList (): tx_area_style_t[] {
      const fin: tx_area_style_t[] = []
      for (const txArea of this.vw.txList) {
        const vc = getVwTxColor(txArea.mac, this.vw)
        const style = `border: 5px solid ${vc.bd};` +
                      `left: ${txArea.column * this.screenSize.width}px;` +
                      `top:  ${txArea.row * this.screenSize.height}px;` +
                      `width:  ${txArea.columns * this.screenSize.width}px;` +
                      `height: ${txArea.rows * this.screenSize.height}px;`
        fin.push({style: style, mac: txArea.mac, rotateFlipClass: '', name: getDevName(txArea.mac),
        geometry: {x: -1, y: -1, width: -1, height: -1}})  // TODO: TX name
      }
      // console.log(`vw-${this.vw.id} areas`, fin)
      return fin
    },
  },
  methods: {
    dragEnter (ev: DragEvent) {
      console.log('Enter', ev)
    }
  }
})
